export enum OrientedBy {
  assoc = 'Associations',
  wordOfMouth = 'Bouche à oreille (amis, famille, internet, ...)',
  publicInstitution = 'Institution publique (Mairie, CCAS, MDMS, CARSAT…)',
  localMission = 'Mission locale',
  franceTravail = 'France Travail',
  other = 'Autre',
}

export const labelsByOrientedBy: Map<OrientedBy, string> = new Map<OrientedBy, string>(
  Object.keys(OrientedBy).map((x: string) => [x, OrientedBy[x]] as [OrientedBy, string]),
);
